/**
    * @description      : 
    * @author           : 
    * @group            : 
    * @created          : 08/10/2025 - 21:23:16
    * 
    * MODIFICATION LOG
    * - Version         : 1.0.0
    * - Date            : 08/10/2025
    * - Author          : 
    * - Modification    : 
**/


import React, { useEffect, useState } from "react";
import GoogleLogin from "../../components/pages/googleLogin";
import RegistrationNavbar from "../../components/shared/registrationNavbar";
import RegistrationFooter from "../../components/shared/registrationFooter";
import { Button } from "react-bootstrap";
import { Image } from "react-bootstrap";
import {
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signOut,
} from "firebase/auth";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/shared/loader";
import { Link } from "react-router-dom";
import images from "../../images/index";
import { signInWithPopup } from "firebase/auth";
import { auth, facebookProvider } from "../../firebase";
import { locationapi } from "../../api/locationapi";

const Login: React.FC = () => {
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [facebookError, setfacebookError] = useState("");
  const [loader, setLoader] = useState(false);
  const [forgetPassword, setForgetPassword] = useState(false);
  const navigate = useNavigate();
  
  // handle Input Value
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Handle login with API token exchange
  const handleLoginSuccess = async () => {
    try {
      navigate("/dashboard");
    } catch (error) {
      console.error("Error getting API token:", error);
      // Continue to dashboard anyway, the API service will handle token exchange when needed
      navigate("/dashboard");
    } finally {
      setLoader(false);
    }
  };

  const facebookLogin = () => {
    signOut(auth);
    setLoader(true);
    signInWithPopup(auth, facebookProvider)
      .then(async () => {
        
        // Check location after successful authentication
        const locationCheck = await locationapi.trackUserLocation();
        
        // Handle blocked location
        if (locationCheck.blocked) {
          // Sign out the user
          await signOut(auth);
          setfacebookError(locationCheck.message || "PV-GlareCheck is not available in your region");
          setLoader(false);
          return;
        }

        handleLoginSuccess();
        
      })
      
      .catch((error: Error) => {
        console.error(error);
        setfacebookError(`Error in facebook sign in`);
        setLoader(false);
      });
  };

  const handleLogin = async () => {
    setForgetPassword(false);
    setLoader(true);
    setError("");
    
    try {
      await signInWithEmailAndPassword(auth, formData.email, formData.password);

      const locationCheck = await locationapi.trackUserLocation();
    
      // Handle blocked location
      if (locationCheck.blocked) {
        // Sign out the user
        await signOut(auth);
        setError(locationCheck.message || "PV-GlareCheck is not available in your region");
        setForgetPassword(false);
        setLoader(false);
        return;
      }
      if (auth.currentUser) {
        const token = await auth.currentUser.getIdToken();
        localStorage.setItem('firebaseToken', token);
      }
      await handleLoginSuccess();
    } catch (error) {
      setError("Invalid Email or Password");
      setForgetPassword(true);
      setLoader(false);
    }
  };

  useEffect(() => {
    // If user is already logged in, get API token and navigate to dashboard
    if (auth.currentUser) {
      setLoader(true);
      handleLoginSuccess();
    }
  }, [auth.currentUser]);

  return (
    <React.Fragment>
      <RegistrationNavbar />
      <div className="text-center my-5">
        <div className="d-flex mb-3">
          <Link
            style={{ width: "fit-content", position: "absolute" }}
            className="text-decoration-none"
            to="/registered"
          >
            <div className="mx-3 mt-1 d-flex align-items-center">
              <Image src={images.leftArrow} alt="back_arrow" />
              <h1 className="d-none d-sm-inline  mx-2 backToDashboard my-0">
                Sign up
              </h1>
            </div>
          </Link>
          <h1 className="newProjects mx-auto pe-5">Login</h1>
        </div>
        <form>
          <input
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                document.getElementById("password")?.focus();
              }
            }}
            name="email"
            onChange={handleInputChange}
            className="loginInput my-3"
            type="email"
            placeholder="Email"
          />
          <br />
          <input
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleLogin();
              }
            }}
            id="password"
            name="password"
            onChange={handleInputChange}
            className="loginInput my-3"
            type="password"
            placeholder="Password"
          />
          <br />
          <small className="text-danger error">{error} </small>
        </form>
        <p className="loginOR mt-1">Or</p>
        <GoogleLogin />
        <br />
        <Button
          onClick={facebookLogin}
          className="facebookLogin my-3 "
          variant="none"
        >
          <Image width={20} className="pb-1 mx-2" src={images.FacebookIcon} /> Facebook
        </Button>
        <br />
        <small className="error d-block">{facebookError}</small>
        <br />
        {forgetPassword && (
          <small
            onClick={() => navigate("/resetpassword")}
            className="forgetpassword"
          >
            Forgot login credentials?
          </small>
        )}
        <br />
        <Button onClick={handleLogin} className="login my-5">
          {loader ? (
            <span className="d-flex justify-content-center">
              {" "}
              <Loader />
            </span>
          ) : (
            "Login"
          )}
        </Button>
      </div>
      <RegistrationFooter />
    </React.Fragment>
  );
};

export default Login;